import { TaskTriggerType } from "../../typings/board/TaskScheduler";

export function taskTriggerDescriptionFilter() {
    return function (input: TaskTriggerType) {
        switch (input) {
            case TaskTriggerType.Daily: return "Daily";
            case TaskTriggerType.Monthly: return "Monthly";
            case TaskTriggerType.Time: return "One Time";
            case TaskTriggerType.Weekly: return "Weekly";
            case TaskTriggerType.MonthlyDOW: return "Monthly (Days of the week)";
            default: return "N/D";
        }
    }
}


// WEBPACK FOOTER //
// ./app/scheduler/scheduler.filter.ts